module.exports = __webpack_public_path__ + "img/casasbahia_logo.cecb59ef.svg";